/* eslint-disable max-len */
import React from 'react';

export const GradientIcon = props => (
  <svg width="40px" height="40px" viewBox="0 0 40 40" {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-143.000000, -242.000000)">
        <g transform="translate(143.000000, 242.000000)">
          <g>
            <g>
              <rect stroke="currentColor" x="0.5" y="0.5" width="39" height="39" rx="1" />
              <g>
                <g transform="translate(0.726273, 1.000000)">
                  <path
                    stroke="currentColor"
                    strokeWidth="1"
                    d="M38.7737269,-1.20727103 L-1.20694257,38.7810917 L38.7737269,38.7810917 L38.7737269,-1.20727103 Z"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
